import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../../services/common-request-response.service';
import { ClassBaseService } from './../../../services/class-base.service';
import { CommonAuthenticationService } from './../../../services/common-authentication.service';
import { DataService } from './../../../services/data.service';
import { NotificationService } from './../../../services/notification.service';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { StudentWorkCardComponent } from './student-work-card/student-work-card.component';
import { StudentScholasticCardComponent } from './student-scholastic-card/student-scholastic-card.component';


@Component({
  selector: 'app-student-profile-experience',
  templateUrl: './student-profile-experience.component.html',
  styleUrls: ['./student-profile-experience.component.scss']
})
export class StudentProfileExperienceComponent implements OnInit, OnDestroy {
  @Input() studentUserId: number;
  @Input() studentProfileId: number;

  @ViewChild('workCard') workCard: StudentWorkCardComponent;
  @ViewChild('scholasticCard') scholasticCard: StudentScholasticCardComponent;
  @Input() isStudenFirstLogIn: boolean;
  subs: Subscription[] = [];

  profileData: any;

  fourthPageCloseFlag = false;
  studentProfileLoader = false;

  constructor(
    private notificationService: NotificationService,
    private dataService: DataService,
    private _commonAuthService: CommonAuthenticationService,
    private _classBaseService: ClassBaseService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private router: Router,
    private _commonService: CommonService,
    private _commonDataSharedService: CommonDataSharedService,
    private routes: ActivatedRoute
  ) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    this.getProfileFourData();

    this.subs.push(
      this._commonDataSharedService.saveProfile.subscribe(() => {
        if (this.workCard.workFormsTouched || this.scholasticCard.scholasticFormsTouched) {
          const currentRoute = this.routes.snapshot.url[0].path;
          this._commonDataSharedService.saveModal.next(currentRoute);
          this._commonDataSharedService.duplicateContact.next(true);
        }
      }),
      this._commonDataSharedService.studentProfileNavigation
        .subscribe(() => {
          this._commonService.setDataWithoutObservable(this.fourthPageCloseFlag, 'studentProfileDirty');
        }));
  }

  saveData() {
    const module = this._commonAuthService.getModule();
      const workData = this.workCard.getStudentWorkData();
      const subjectData = this.scholasticCard.getSubjectData();

      const obj = {
        studentUserId: this.studentUserId.toString(),
        workDescription: workData.workDes,
        volunteerHours: workData.volHours,
        favoriteSubjectClassIds: subjectData.favSub,
        otherFavoriteSubject: subjectData.otherFavSubject,
        leastFavoriteClassIds: subjectData.leastFav,
        otherLeastFavoriteSubject: subjectData.otherLeastFavSubject,
        workTypeClassIds: null,
      };

      this.subs.push(this._commonRequestResponseService.postWithHeader('student/questionnaire4', obj)
        .subscribe(() => {
          const localData = JSON.parse(localStorage.getItem('loginUserData'));
          localData.isFirstLogOn = false;
          this._commonDataSharedService.isFirstLogOn.next(true);
          localStorage.setItem('loginUserData', JSON.stringify(localData));
          this.notificationService.show('success', 'Profile saved successfully');
        }, () => {
          this.notificationService.show('error', 'Error while saving profile data');
        }));
   
  }

  getProfileFourData() {
    this.studentProfileLoader = true;
    const selectedType = {
      studentUserId: this.studentUserId,
      profileId: this.studentProfileId
    };

    this.subs.push(this._commonRequestResponseService.postWithHeader('student/getprofile1/', selectedType, ['profileId'])
      .subscribe(
        (getProfileFourData: any) => {
          if (getProfileFourData && getProfileFourData.data) {
            this.profileData = getProfileFourData.data;
          }
          this.studentProfileLoader = false;
        },
        () => {
          this.studentProfileLoader = false;
          this.notificationService.show('error', 'Error while fetching west states');
        }));
  }

  ngOnDestroy() {
    const module = this._commonAuthService.getModule();

    if (this.studentProfileLoader) {
      this.subs.forEach((sub: Subscription) => {
        sub.unsubscribe();
      });
    }
  }
}
